<template>
  <div>
    <Carousel />
  </div>
</template>

<style>
html,
body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: rgba(28, 99, 156, 0.034);
  background: linear-gradient(rgba(28, 99, 156, 0.034), rgba(28, 99, 156, 0.1));
}
</style>

<script>
import Carousel from "./Carousel";

export default {
  components: { Carousel }
};
</script>